import { render, staticRenderFns } from "./DockerRegistriesModal.vue?vue&type=template&id=5b83ef44&scoped=true"
import script from "./DockerRegistriesModal.vue?vue&type=script&lang=js"
export * from "./DockerRegistriesModal.vue?vue&type=script&lang=js"
import style0 from "./DockerRegistriesModal.vue?vue&type=style&index=0&id=5b83ef44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83ef44",
  null
  
)

export default component.exports